import { del, get, post, putForm } from "utils/Service";
import { CreateResourceInfo, ResourceInfo, UserAccess } from "./ResourceTypes";

const ENDPOINT = "/api/resources";
const RIGHTS_SUFFIX = "rights";
const CONTENT_SUFFIX = "content";

/**
 * @deprecated
 **/
export function getResources(): Promise<ResourceInfo[]> {
	return get(ENDPOINT).then(response => response.json());
}

/**
 * @deprecated
 **/
export function getResourceInfo(id: number): Promise<ResourceInfo> {
	return get(`${ENDPOINT}/${id}`).then(response => response.json());
}

/**
 * @deprecated
 **/
export function getResourceRights(id: number): Promise<UserAccess[]> {
	return get(`${ENDPOINT}/${id}/${RIGHTS_SUFFIX}`).then(response =>
		response.json()
	);
}

/**
 * @deprecated
 **/
export function getResourceContent(id: number): Promise<Blob> {
	return get(`${ENDPOINT}/${id}/${CONTENT_SUFFIX}`).then(response => {
		if (response.status !== 200) {
			throw new Error(response.statusText);
		}
		return response.blob();
	});
}

/**
 * @deprecated
 **/
export function createResource(info: CreateResourceInfo): Promise<string> {
	return post(ENDPOINT, info).then(response => {
		if (response.status !== 201) {
			throw new Error(response.statusText);
		}

		const location = response.headers.get("location");
		if (location === null) {
			throw new Error("Missing location header!");
		} else {
			return location;
		}
	});
}

/**
 * @deprecated
 **/
export function updateResourceContent(
	id: number,
	data: FormData
): Promise<void> {
	return putForm(`${ENDPOINT}/${id}/${CONTENT_SUFFIX}`, data).then(
		response => {
			if (response.status !== 200) {
				throw new Error(response.statusText);
			}
		}
	);
}

/**
 * @deprecated
 **/
export function deleteResource(id: number): Promise<void> {
	return del(`${ENDPOINT}/${id}`).then(response => {
		if (response.status !== 204) {
			throw new Error(response.statusText);
		}
	});
}
